import React, { useEffect } from "react";
import moment from "moment";


const GridItem = ({ data }) => {
  return (
    <div className="col-lg-4 col-md-6 mb-5 pb-md-2">
      <div className="form-row">
        <div className="col-md-4">
          <img
            className="img-fluid rounded"
            src={
              data?.image || "https://www.outlookindia.com/public/uploads/editor/2021-10-08/1633687225.jpg"
            }
            alt={data?.name || ''}
          />
        </div>
        <div class="col">
          <div class="brand-Primary-2 f-medium pb-1">
            <span class="text-defused">Sold: </span>
            {data.last_updated ? moment(parseFloat(data.last_updated) * 1000).fromNow() : ''}
          </div>
          <h4 class="f-16 text-primary f-bold"> {data.name}</h4>
          <h6 class="f-10 brand-Primary-2 pb-2 pt-1">
            {data.description},{data.attributes}
          </h6>
          <p class="secondary-text f-12">Price</p>
          <h4 class="f-16 text-primary f-medium">{data.current_price}</h4>
        </div>
        {data.Seller && (
          <div class="d-flex justify-content-between flex-wrap w-100 mt-2">
            <div class="">
              <div class="secondary-text f-10">Seller</div>
              <div class="brand-Primary-2 f-12 f-medium">{data.sellers}</div>
            </div>
            <div class="">
              <div class="secondary-text f-10">Buyer</div>
              <div class="brand-Primary-2 f-12 f-medium">{data.buyers}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

//$ 310,618.38 (99.0000 ETH)

export default GridItem;
